import React from 'react';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  onClick?: () => void;
}
const CHECKOUT_URL = 'https://maestros.ebookditales.com/cart/44746207461512:1';
export function CTAButton({
  children,
  className = '',
  fullWidth = false,
  onClick
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (onClick) {
      onClick();
    }
    // Redirect to checkout
    window.location.href = CHECKOUT_URL;
  };
  return <button onClick={handleClick} className={`
        group relative overflow-hidden rounded-lg bg-gradient-to-b from-green-500 to-green-600 
        px-8 py-4 font-bold text-white shadow-[0_4px_0_rgb(22,101,52)] 
        transition-all hover:-translate-y-1 hover:shadow-[0_6px_0_rgb(22,101,52)] 
        active:translate-y-1 active:shadow-none
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-258">
      <div className="relative z-10 flex items-center justify-center gap-2 uppercase tracking-wide" data-id="element-259">
        {children}
        <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" data-id="element-260" />
      </div>

      {/* Shine effect */}
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition-transform duration-1000 group-hover:animate-shimmer" data-id="element-261" />
    </button>;
}